import type { RouteObject } from "react-router";
import { AI_ROUTES } from "../constants/ai-routes";

export const aiRoutes: RouteObject = {
	children: [
		{
			path: AI_ROUTES.CHAT,
			lazy: async () => {
				const { default: AIChatPage } = await import("../pages/ai-chat-page");
				return { Component: AIChatPage };
			},
		},
	],
};
